// Generated types for Group
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { PrivateNodeReadAPI, PrivateNodeWriteAPI } from '../../shared/types/privatenode';
import { PrivateNodeReadAPISchemaObject, PrivateNodeWriteAPISchemaObject } from '../../shared/types/privatenode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface GroupReadAPI extends PrivateNodeReadAPI {
  /** Role: a standard key (owner/admin/member — stamps the template), a custom name (explicit grants), or null (plain group). */
  role?: string | null;
  /** Group name (e.g. 'Editors', or an IdP group). REQUIRED for multi-member groups; single-member auto-grants stay unnamed. */
  name?: string | null;
  /** Creation timestamp (server-set) */
  created_at?: string | null;
  /** Derived unique key: 'user:scope' or 'scope:g:name'. */
  grant_key?: string;
  /** Stored permission pairs '<space>:<Type>:<action>'. Absent at creation = the role's full effective bundle; a supplied list may only narrow it. */
  grants?: string[] | null;
  /** Derived roster tier of the role (yaml `level`); null for plain groups. */
  level?: number | null;
  /** Most privileged tier reachable up the nesting (self included). */
  effective_level?: number | null;
  /** IMPLICIT group (platform organisation only, Features 7): the principal class whose every caller is a member — 'registered' (any authenticated caller) or 'anonymous' (any caller). No roster; membership is decided at check time. Server-set. */
  implicit?: string | null;
  /** True when grants were deliberately narrowed; template sync only re-stamps non-custom groups. */
  grants_custom?: boolean;
  /** A directory group's id in its company's directory: entra:<tenant id>:<object id>; server-set */
  external_id?: string | null;
}

export interface GroupWriteAPI extends PrivateNodeWriteAPI {
  /** Role: a standard key (owner/admin/member — stamps the template), a custom name (explicit grants), or null (plain group). */
  role?: string | null;
  /** Group name (e.g. 'Editors', or an IdP group). REQUIRED for multi-member groups; single-member auto-grants stay unnamed. */
  name?: string | null;
  /** Stored permission pairs '<space>:<Type>:<action>'. Absent at creation = the role's full effective bundle; a supplied list may only narrow it. */
  grants?: string[] | null;
  /** Direct members: users, or groups nesting into this one. */
  holders?: string[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const GroupReadAPISchema: z.ZodType<GroupReadAPI> = PrivateNodeReadAPISchemaObject.extend({
  role: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  created_at: z.string().nullable().optional(),
  grant_key: z.string().optional(),
  grants: z.array(z.string()).nullable().optional(),
  level: z.number().nullable().optional(),
  effective_level: z.number().nullable().optional(),
  implicit: z.string().nullable().optional(),
  grants_custom: z.boolean().optional(),
  external_id: z.string().nullable().optional(),
}).passthrough();

export const GroupWriteAPISchema: z.ZodType<GroupWriteAPI> = PrivateNodeWriteAPISchemaObject.extend({
  role: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  grants: z.array(z.string()).nullable().optional(),
  holders: z.array(z.string()).optional(),
}).passthrough();
